import { Box, Tooltip, Typography } from '@mui/material';
import moment from 'moment';

import { IcClock } from '@/assets/images';
import { DATE_TIME_FORMAT, TIME_FORMAT } from '@/config';

import { RadioClicksItem } from '../styles';

interface RadioClicksTimestampProps {
  timestamp: string;
}

export const RadioClicksTimestamp = ({
  timestamp,
}: RadioClicksTimestampProps) => (
  <RadioClicksItem sx={{ paddingX: 2 }} className="timestamp">
    <Tooltip title={moment(timestamp).format(DATE_TIME_FORMAT)}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IcClock height="14px" />
        <Typography fontSize={12} fontWeight={500}>
          {moment(timestamp).format(TIME_FORMAT)}
        </Typography>
      </Box>
    </Tooltip>
  </RadioClicksItem>
);
